import React, { Component } from 'react';
import './Home.css'

export default class Home extends Component {
    render() {

        return (
            <div className="ac-page">
                <h1>Oops!</h1>
                <p>We could not find that page. Please check the original link and try again.</p>
            </div>
        );
    }
}